import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { DataTable } from '../../../../ui';
import { MOCK_BILLING_HISTORY } from '../constants';
import { getBillingHistoryColumns } from '../functions';

export const BillingHistoryTab: React.FC = () => {
  const handleDownload = (id: string): void => {
    console.log(`Downloading invoice ${id}`);
  };

  const columns = getBillingHistoryColumns(handleDownload);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 900, color: 'text.primary', letterSpacing: '-0.03em', mb: 0.5 }}>
          Billing History
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
          View and download your past invoices.
        </Typography>
      </Box>

      <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
        <DataTable
          columns={columns}
          data={MOCK_BILLING_HISTORY}
          rowsPerPage={10}
          totalRecords={MOCK_BILLING_HISTORY.length}
          totalPages={1}
          currentPage={1}
          onPageChange={() => {}}
        />
      </Paper>
    </Box>
  );
};
